import IconButton from 'components/common/IconButton';
import React from 'react';
import { Card, Col, Button, Row } from 'react-bootstrap';

const ProductFooter = () => {
 return (
  <Card>
   <Card.Body>
    <Row className="flex-between-center">
     <Col md>
      <h5 className="mb-2 mb-md-0">Ya casi terminas</h5>
     </Col>
     <Col xs="auto">
      <Button variant="link" className="text-secondary fw-medium p-0 me-3" type="button">
       Descartar
      </Button>
      <IconButton icon="plus" type="submit" transform="shrink-3" variant="falcon-primary">
       Agregar producto
      </IconButton>
     </Col>
    </Row>
   </Card.Body>
  </Card>
 );
};

export default ProductFooter;
